import React, { Component } from 'react';
import Page from '../containers/page';
// import BankIdModal from '../components/bankIdModal';
import { API_ENDPOINT } from '../constants';
import ErrorModal from './errorModal';
import { getSearchParams } from '../helpers/linkHelper';

class VideoCallStarted extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props.initialData,
            check: true

        };

    }


    componentDidMount() {

    }
    startVideoChat = (data) => {
        if (data) {
            if (data.link.indexOf('initiator') !== -1) {
                data.link = '/' + data.link
            }

            if (data?.guestData) {
                let link = `${data.link}&guestId=${data.guestData.guestId}`
                this.props[0].history.push(link)
            } else {
                this.props[0].history.push(data.link)
            }
        } else {
            this.props[0].history.push('/')
        }
    }
    componentDidUpdate() {
        let params = {};
        params = getSearchParams(this.props[0].location.search, {})
        const guestId = params?.guestId ?? null;

        if (this.state.check) {
            if (this.props[0].location) {
                fetch(API_ENDPOINT + '/data/video-call-started/' + this.props[0].match.params.id, {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        guestId: guestId
                    })
                }).then(res => res.json()).then((result) => {
                    let alias = result?.groupAlias ?? null;
                    delete result.groupAlias;

                    let data = result && Object.keys(result).length > 0 ? result : null;
                    if (guestId || result?._guestId || data.guestIdNotFound) {
                        if (data && !data.guestIdNotFound) {
                            this.startVideoChat(data)
                        } else {
                            this.setState({
                                errorExpiredLink: {
                                    message: 'This meeting link is no longer valid'.translate(this.props.lang),
                                    redirectLink: `/${alias}`
                                }
                            })
                            console.log(alias, this.props.lang)
                        }
                    } else {
                        this.startVideoChat(data)
                    }


                    // if (result?.bundleId) {
                    //     let bundleId = result.bundleId;
                    //     console.log('bundleId', bundleId)
                    //     try {
                    //         if (bundleId && typeof window !== 'undefined') {
                    //             // let url = `clinic-app://${bundleId}`
                    //             // this.appIframe.src = bundleId + '://';
                    //             let url = `${bundleId}://`;

                    //             var linker = new DeepLinker({
                    //               onIgnored: function() {
                    //                 console.log('browser failed to respond to the deep link');
                    //                   this.startVideoChat(result)
                    //               },
                    //               onFallback: function() {
                    //                 console.log('dialog hidden or user returned to tab');
                    //                   this.startVideoChat(result)
                    //               },
                    //               onReturn: function() {
                    //                 console.log('user returned to the page from the native app');
                    //                   this.startVideoChat(result)
                    //               },
                    //             });

                    //             linker.openURL(url);


                    //         }
                    //     } catch (error) {
                    //         this.startVideoChat(result)
                    //     }
                    // } else {
                    //     this.startVideoChat(result)
                    // }




                })

                this.setState({
                    check: false
                })
            }
        }

    }

    render() {


        return (
            <div>
                {this.state.errorExpiredLink ?
                    <ErrorModal lang={this.props.lang}
                        isOpen={this.state.errorExpiredLink}
                        toggle={() => {
                            if (this.state.errorExpiredLink.redirectLink) {
                                this.props[0].history.push(this.state.errorExpiredLink.redirectLink)
                            } else {
                                this.props[0].history.push('/')
                            }
                        }}

                    >
                        {this.state.errorExpiredLink?.message}
                    </ErrorModal>
                    :
                    null
                }
                <iframe ref={(node) => this.appIframe = node} onLoad={() => {
                    console.log('loaded')
                }} width="1" height="1" style={{ visibility: "hidden" }}></iframe>
            </div >
        );
    }
}



export default Page(VideoCallStarted);
